export default __webpack_public_path__ + "static/media/16x9.950ac044.svg";